import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import * as ReduxFormKeys from 'af-constants/reduxForms';

import NotificationTimeSettingsForm from 'af-components/NotificationTimeSettingsForm/NotificationTimeSettingsForm';

import * as OrganizationsettingsActions from 'af-actions/organizationSettings';

import type { RegistrationAndDeactivationNotificationTimeSettingsFM } from './formModel';
import { NOTIFICATION_TYPE } from '../constants';

interface TimeSettings {
	notificationTime: string;
	timezone: string;
}

type Props = ConnectedProps<typeof connector>;

const NotificationTimeSettings: React.FC<Props> = (props) => {

	const [timeSettings, setTimeSettings] = React.useState<Nullable<TimeSettings>>(null);

	const {
		findOrganizationNotificationTimeSettings,
		updateOrganizationNotificationTimeSettings,
	} = props;

	const fetchTimeSettings = React.useCallback(async () => {
		const _timeSettings = await findOrganizationNotificationTimeSettings(NOTIFICATION_TYPE);
		setTimeSettings(_timeSettings);
	}, [findOrganizationNotificationTimeSettings]);

	React.useEffect(() => {
		fetchTimeSettings();
	}, [fetchTimeSettings]);

	const updateTimeSettings = React.useCallback(async (form: RegistrationAndDeactivationNotificationTimeSettingsFM) => {
		await updateOrganizationNotificationTimeSettings(NOTIFICATION_TYPE, form);
		await fetchTimeSettings();
	}, [fetchTimeSettings, updateOrganizationNotificationTimeSettings]);

	return (
		<NotificationTimeSettingsForm
			form={ReduxFormKeys.ORGANIZATION_REGISTRATION_AND_DEACTIVATION_NOTIFICATION_TIME_SETTINGS}
			initialValues={timeSettings ?? undefined}
			onSubmit={updateTimeSettings}
		/>
	);
};

function mapDispatchToProps() {
	return {
		findOrganizationNotificationTimeSettings: OrganizationsettingsActions.findOrganizationNotificationTimeSettings,
		updateOrganizationNotificationTimeSettings: OrganizationsettingsActions.updateOrganizationNotificationTimeSettings,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType>(
	React.memo,
	connector
);

export default enhance(NotificationTimeSettings);
